export {default} from './virtual-scroller.vue'